import RoleLogin from "@/components/feature/auth/RoleLogin";

export default function OgretmenGiris() {
  return <RoleLogin role="ogretmen" />;
}